<mat-card class="m-4" *ngIf="catalogos$ | async as catalogos">
  <mat-card-header>
    <mat-card-title style="font-size: 20px;font-weight: 500;">ACUERDO MR. B</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    Mover
    <form [formGroup]="formAcuerdo">
      <div class="grid grid-cols-2 gap-4">
        <mat-form-field class="flex-grow">
          <mat-label>Nueva Forma de Envío</mat-label>
          <mat-select
            (selectionChange)="disable()"
            formControlName="tipo_forma_envio"
            name="tipo_forma_envio">
            <mat-option
              *ngFor="let tipo of catalogos.catFormaEnvio"
              [value]="tipo.id">
              {{ tipo.descripcion }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field
          class="flex-grow"
          *ngIf="formAcuerdo?.get('tipo_forma_envio')?.value">
          <mat-label>Tema</mat-label>
          <input
            matInput
            type="text"
            name="nombreTema"
            formControlName="nombreTema" />
        </mat-form-field>
      </div>
      <div *ngIf="formAcuerdo.get('tipo_forma_envio')?.value">
        <div class="!flex justify-between gap-3">
          <div>
            <p style="color: #9b9b9b; font-weight: 300; font-size: 0.8rem">
              Descripción del tema
            </p>
            <p
              class="!bold"
              [innerHTML]="formAcuerdo.get('descripcionTema_html')?.value"></p>
          </div>
          <mat-slide-toggle
            name="banEsImpreso"
            formControlName="banEsImpreso"
            labelPosition="before"
            hideIcon="true"
            class="mb-5 mt-5"
            [color]="'primary'">
            Impreso
          </mat-slide-toggle>
        </div>

        <section
          class="detalle-section-entradas mb-4"
          *ngIf="formAcuerdo.get('entradas')?.value.length > 0">
          <!-- Encabezados de columnas -->
          <div class="grid grid-cols-3 bg-gray-200 font-bold">
            <div
              class="container-material col-span-1 border border-gray-300 p-2 border-r-transparent">
              <p>Material</p>
            </div>
            <div
              class="container-entregables col-span-1 border border-gray-300 p-2 border-r-transparent">
              <p>Entregables</p>
            </div>
            <div
              class="container-archivos col-span-1 border border-gray-300 p-2">
              <p>Archivos Adjuntos</p>
            </div>
          </div>

          <!-- Iteración sobre las entradas -->
          @for (entrada of formAcuerdo.get('entradas')?.value; track entrada) {
          <div class="grid grid-cols-3 bg-white">
            <!-- Columna de material -->
            <div
              class="material col-span-1 border border-gray-300 p-2 border-r-transparent !flex !justify-between !cursor-pointer">
              <a
                routerLink="/entrada/{{ entrada.id_categorizacion }}/{{
                  entrada.id_entrada
                }}"
                target="_blank"
                class="entradaLink !underline !text-blue-700">
                {{ entrada.documentoSoporte }}
              </a>

              <a
                *ngIf="entrada.nuevaEntrada"
                type="button"
                (click)="eliminarEntrada(entrada)"
                aria-label="eliminarEntrada">
                <mat-icon>delete</mat-icon>
              </a>
            </div>

            <!-- Entregables -->
            <div
              class="entregables col-span-1 border border-gray-300 p-2 border-r-transparent">
              <div
                *ngFor="let entregable of entrada.entregables; let j = index">
                <div
                  class="estatus-container flex gap-1 justify-between items-center !cursor-pointer"
                  *ngIf="
                    entregable.id_edo_entregable !== 5 &&
                    entregable.id_edo_entregable !== 6
                  ">
                  @if (entregable.nombreEntregable.trim() !== '') {
                  <a
                    href="{{ entregable.urlEntregable }}"
                    target="_blank"
                    #tooltip="matTooltip"
                    [matTooltip]="entregable.nombreEntregable"
                    matTooltipPosition="above"
                    aria-label="Button that displays a tooltip that hides when scrolled out of the container"
                    class="example-button !underline !text-blue-700"
                    matTooltipClass="tooltip-full-width">
                    {{
                      entregable.nombreEntregable.length > 22
                        ? entregable.nombreEntregable.substring(0, 22) + "..."
                        : entregable.nombreEntregable
                    }}
                  </a>
                  }@else {
                  <a
                    (click)="
                      descargaEntregable(
                        entrada.id_entrada,
                        entregable.id_entregable
                      )
                    "
                    class="entradaLink !underline !text-blue-700"
                    ng-if="entregable.nombreEntregable.trim() === ''">
                    Adjuntar Archivo
                  </a>
                  }
                </div>
              </div>
            </div>

            <!-- Archivos -->
            <div class="archivos col-span-1 border border-gray-300 p-2">
              <div
                *ngFor="let archivo of entrada.archivos; let k = index"
                class="archivo flex justify-between gap-3 pb-1 !cursor-pointer">
                <a
                 (click)="verArchivo(entrada,archivo)"
                  target="_blank"
                  #tooltip="matTooltip"
                  [matTooltip]="archivo.nombre_archivo"
                  matTooltipPosition="above"
                  aria-label="Button that displays a tooltip that hides when scrolled out of the container"
                  class="example-button !underline !text-blue-700"
                  matTooltipClass="tooltip-full-width">
                  {{
                    archivo.nombre_archivo.length > 22
                      ? archivo.nombre_archivo.substring(0, 22) + "..."
                      : archivo.nombre_archivo
                  }}
                </a>
                <a
                  (click)="verArchivo(entrada,archivo)"
                  target="_blank"
                  mat-mini-fab
                  color="primary"
                  aria-label="Remove file">
                  <mat-icon>remove_red_eye</mat-icon>
                </a>
              </div>
            </div>
          </div>
          }
        </section>
        <div class="grid grid-cols-2 gap-4">
          <mat-form-field class="w-full">
            <mat-label>Empresa</mat-label>
            <mat-select
              (valueChange)="seleccionarEmpresa($event)"
              formControlName="empresa"
              name="empresa">
              <mat-option
                *ngFor="let cat of catalogos.catEmpresa"
                [value]="cat">
                {{ cat.descripcion }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field
            class="w-full"
            *ngIf="formAcuerdo?.get('empresa')?.value?.id === 'Otro'">
            <mat-label>Ingresa otra empresa</mat-label>
            <input
              matInput
              type="text"
              name="nombreTema"
              formControlName="nombreTema"
          /></mat-form-field>
          <mat-form-field class="w-full">
            <mat-label>Tipo de despacho</mat-label>
            <mat-select
              formControlName="id_tipo_despacho"
              name="id_tipo_despacho">
              <mat-option
                *ngFor="let cat of catalogos.catTipoDespacho"
                [value]="cat.id">
                {{ cat.descripcion }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <section class="detalle-section-tres">
          <div
            class="select-custom-entradas"
            style="width: 100%; position: relative"
            *ngIf="entradas$ | async as entr">
            <mat-form-field class="example-full-width" style="width: 100%">
              <mat-label>Buscar Entrada</mat-label>
              <mat-icon matPrefix>search</mat-icon>
              <input
                type="text"
                placeholder="Buscar Entrada"
                aria-label="Number"
                formControlName="entradaSelected"
                name="entradaSelected"
                matInput
                (input)="onInput($event, formAcuerdo)"
                   (focus)="onFocus(formAcuerdo)"
                  (blur)="onBlur(formAcuerdo)" />
            </mat-form-field>

            <ul
              *ngIf="formAcuerdo.get('entradaSelected')?.value !== ''  ||
                  mostrarEntradas"
              class="custom-dropdown">
              @if (listaEntradas.length>0) {
              <li *ngFor="let entrada of listaEntradas">
                <button (click)="selectEntrada(entrada, listaEntradas)">
                  {{ entrada.nombreEntradaCompleto }}
                </button>
              </li>
              }@else {
              <li class="!p-2">No se encuentra la entrada.</li>
              }
            </ul>
          </div>
        </section>

        <div class="!flex !justify-end gap-4">
          <button class="!uppercase" mat-raised-button (click)="cancelar()">
            Cancelar
          </button>
          <button
            [disabled]="!isFormValid()"
            color="primary"
            class="full-width-button !uppercase"
            (click)="guardar()"
            mat-flat-button>
            Guardar
          </button>
        </div>
      </div>
    </form>
  </mat-card-content>
</mat-card>
